"use client";
import clsx from "clsx";
import { type Control, type FieldValues, type Path, useController } from "react-hook-form";
import "react-phone-number-input/style.css";
import ReactPhoneNumberInput from "react-phone-number-input";
import fr from "react-phone-number-input/locale/fr.json";

type Props<T extends FieldValues> = {
  id: string;
  label: string;
  name: Path<T>;
  control: Control<T>;
  placeholder?: string;
  className?: string;
};
export const PhoneInput = <T extends FieldValues>({ id, label, name, control, placeholder, className }: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <div className={className}>
      <label
        htmlFor={id}
        className={clsx("text-base font-bold", {
          "text-[#C92A2A]": error,
          "text-[#22201F]": !error,
        })}
      >
        {label}
      </label>
      <div
        className={clsx(
          "mt-2 bg-white rounded-lg border py-3 px-4 w-full text-base font-normal placeholder:text-[#B8B8B8] flex items-center space-x-1",
          {
            "text-[#C92A2A] border-[#C92A2A]": error,
            "text-[#22201F] border-[#E5E5E5]": !error,
          },
        )}
      >
        <span className="whitespace-nowrap">Indicatif :</span>
        <ReactPhoneNumberInput
          placeholder={placeholder || "Numéro de téléphone"}
          defaultCountry="FR"
          countryOptionsOrder={["FR", "BE", "CH"]}
          labels={fr}
          numberInputProps={{ className: "border-none focus:outline-hidden pl-1", id }}
          value={field.value}
          onChange={(v) => field.onChange(v || "")}
          onBlur={field.onBlur}
          ref={field.ref}
          disabled={field.disabled}
        />
      </div>
      {error?.message && <p className="text-[#C92A2A] text-xs leading-5 mt-1">{error.message}</p>}
    </div>
  );
};
